import { toKebabCaseTag } from './toKebabCaseTag'

export class TagRegistry {
    private readonly typeToTagMap = new Map<string, string>()
    private readonly tagToTypeMap = new Map<string, string>()

    private readonly componentIdToTypeMap = new Map<string, string>()

    get typeToTagEntries(): IterableIterator<[string, string]> {
        return this.typeToTagMap.entries()
    }

    registerComponent(componentId: string, componentType: string): void {
        this.componentIdToTypeMap.set(componentId, componentType)
    }

    getTypeByComponentId(componentId: string): string | undefined {
        return this.componentIdToTypeMap.get(componentId)
    }

    register(componentType: string): void {
        this.registerWithTag(componentType, toKebabCaseTag(componentType))
    }

    registerWithTag(componentType: string, htmlTag: string): void {
        if (this.typeToTagMap.has(componentType)) {
            throw new Error(`Component type "${componentType}" is already registered`)
        }

        const normalizedTag = htmlTag.toLowerCase()

        if (this.tagToTypeMap.has(normalizedTag)) {
            throw new Error(
                `HTML tag "${normalizedTag}" is already registered for component type "${this.tagToTypeMap.get(
                    normalizedTag,
                )}"`,
            )
        }

        this.typeToTagMap.set(componentType, htmlTag)
        this.tagToTypeMap.set(normalizedTag, componentType)
    }

    getTagByType(componentType: string): string | undefined {
        return this.typeToTagMap.get(componentType)
    }

    getTypeByTag(htmlTag: string): string | undefined {
        return this.tagToTypeMap.get(htmlTag.toLowerCase())
    }
}
